export default __webpack_public_path__ + "static/media/IntegrationCloudApi.45730fde.jpg";